<template>
    <x-menu
        offset-y
        top
        right
        open-on-hover
        :width="width"
        nudge-top="9"
        :content-class="color"
    >
        <template v-slot:activator="{ on }">
            <slot name="icon" :on="on">
                <span class="action-icon circle" :class="computedIconColor" v-on="on">
                    <x-icon>{{ icon }}</x-icon>
                </span>
            </slot>
        </template>

        <slot />
    </x-menu>
</template>

<script>
    export default {
        name: 'OffersIcon',
        props: {
            icon: String,
            iconColor: String,
            color: String,
            width: {
                type: [String, Number],
                default: 138
            }
        },
        computed: {
            computedIconColor() {
                return this.iconColor || this.color;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .circle {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        border-radius: 20px;
        background: $color-body-text;
        vertical-align: middle;

        &.action-icon {
            cursor: pointer;
            transition: opacity $transition-length;

            &:hover {
                opacity: 0.5
            }
        }

        &.black {
            background: $color-black;
        }

        &.green {
            background: $color-green;
        }

        &.yellow {
            background: $color-yellow;
        }

        &.blue {
            background: $color-blue;
        }

        &.cobalt {
            background: $color-cobalt;

            .x-icon {
                color: $color-teal;
            }
        }

        &.teal {
            background: $color-teal;

            .x-icon {
                color: $color-cobalt;
            }
        }

        .x-icon {
            color: $color-black;
            font-size: rem(12px);
        }
    }

    .x-menu {
        display: none;
    }

    .x-menu__content {
        padding: 10px 5px;
        color: $color-black;
        font-size: rem(12px);
        font-weight: 600;
        text-align: center;
        line-height: 1.2;
        overflow: visible;
        contain: layout;
        transform: translateX(-50%) translateX(10px);

        &.theme--dark {
            background: $color-green;
            border: none;
            border-radius: $border-radius-small;
            box-shadow: 0 2px 25px rgba(0, 0, 0, 0.65);
        }

        &:after {
            content: '';
            position: absolute;
            border: 6px solid transparent;
            border-top-color: $color-black;
            top: 100%;
            left: calc(50% - 6px);
        }

        &.green {
            &:after {
                border-top-color: $color-green;
            }

            :deep(.circle.black) {
                color: $color-green;
            }
        }

        &.yellow {
            &:after {
                border-top-color: $color-yellow;
            }

            :deep(.circle.black) {
                color: $color-yellow;
            }
        }

        &.blue {
            &:after {
                border-top-color: $color-blue;
            }

            :deep(.circle.black) {
                color: $color-blue;
            }
        }

        &.teal {
            &:after {
                border-top-color: $color-teal;
            }

            :deep(.circle.black) {
                color: $color-teal;
            }
        }

        &.cobalt {
            &:after {
                border-top-color: $color-cobalt;
            }

            :deep(.circle.black) {
                color: $color-cobalt;
            }
        }

        &.grey-9 {
            background: $color-grey-9;
            color: $color-white;

            &:after {
                border-top-color: $color-grey-9;
            }

            :deep(.circle.black) {
                color: $color-grey-9;
            }
        }

        :deep() {
            .circle {
                @extend .circle;
                margin-right: 1px;
            }

            p {
                + p {
                    margin-top: 0.5em;
                }

                .light {
                    font-weight: normal;
                }
            }

            .progress-linear-bar {
                margin: 0.8em 0 0;
                color: $color-white;
                font-weight: normal;
            }
        }
    }
</style>
